import { useRef, useState } from "react";
import { forgotEmailStep } from "../interface/IForgotEmail";
import { RECOVER_EMAIL_GENERATE_OTP_ROUTE, RECOVER_EMAIL_VALIDATE_OTP_ROUTE } from "@api-routes/users";
import {
    getResponseToState as getVerificationCodeApiResponseToState,
    getStateToPayload as getPhoneNumberStateToPayload,
    IVerificationCodeApiResponse,
} from "../mappers/postPhoneNumberMapper";
import {
    getResponseToState as getRecoverEmailApiResponseToState,
    getStateToPayload as getVerificationCodeStateToPayload,
    IRecoverEmailApiResponse,
} from "../mappers/postVerificationCodeMapper";
import { useFetch } from "@common/hook/useFetch";
import { BRAND_NAME } from "@constants";

export const useForgotEmail = () => {
    const [actualStep, setActualStep] = useState(forgotEmailStep.initial);
    const [recoverEmail, setRecoverEmail] = useState("");
    const recoverId = useRef("");

    const [postPhoneNumberState, { post: postPhoneNumberCaller }] = useFetch();
    const [postVerificationCodeState, { post: postVerificationCodeCaller }] = useFetch();

    const checkPhoneNumber = (phoneNumber: string) => {
        postPhoneNumberCaller<IVerificationCodeApiResponse>(RECOVER_EMAIL_GENERATE_OTP_ROUTE, {
            body: getPhoneNumberStateToPayload(phoneNumber, BRAND_NAME),
        }).then((otpUuidApiResponse) => {
            if (otpUuidApiResponse) {
                const { otpUuid } = getVerificationCodeApiResponseToState(otpUuidApiResponse);

                if (otpUuid) {
                    setActualStep(forgotEmailStep.verificationCode);
                    recoverId.current = otpUuid;
                }
            }
        });
    };

    const checkVerificationCode = (verificationCode: string) => {
        postVerificationCodeCaller<IRecoverEmailApiResponse>(RECOVER_EMAIL_VALIDATE_OTP_ROUTE, {
            body: getVerificationCodeStateToPayload(verificationCode, recoverId.current, BRAND_NAME),
        }).then((recoverEmailApiResponse) => {
            if (recoverEmailApiResponse) {
                const { email, isVerified } = getRecoverEmailApiResponseToState(recoverEmailApiResponse);

                setRecoverEmail(email);
                const step = isVerified ? forgotEmailStep.success : forgotEmailStep.emailNotVerified;
                setActualStep(step);
            }
        });
    };

    const goToInitialStep = () => {
        setActualStep(forgotEmailStep.initial);
    };

    return {
        actualStep,
        checkPhoneNumber,
        checkVerificationCode,
        goToInitialStep,
        postPhoneNumberState,
        postVerificationCodeState,
        recoverEmail,
    };
};
